import {Component, HostBinding, Input} from '@angular/core';

export type BadgeType = 'primary'|'success'|'warning'|'error';

@Component({
    selector: 'app-badge',
    templateUrl: './badge.component.html',
    standalone: false
})
export class BadgeComponent {
    @HostBinding('class')
    classNames = '';

    @Input()
    set badgeType(type: BadgeType) {
        const defaultClassNames = 'inline-block text-xs font-semibold leading-4 bg-white p-2 px-3 ring-1 ring-opacity-25 rounded';
        if (type === 'success') {
            this.classNames = `text-success ring-success ${defaultClassNames}`;
        }
        if (type === 'warning') {
            this.classNames = `text-warning ring-warning ${defaultClassNames}`;
        }
        if (type === 'error') {
            this.classNames = `text-error ring-error ${defaultClassNames}`;
        }
        if (type === 'primary') {
            this.classNames = `text-primary ring-primary ${defaultClassNames}`;
        }
    }
}
